import NL2BLTLApp from "../components/NL2BLTLApp";

export default function NL2BLTLPage() {
  return <NL2BLTLApp />;
}
